// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.N8gd1raMmPQs9pEAM1SS {
	margin: 10px;
}`, "",{"version":3,"sources":["webpack://./components/ErrorBox/styles.css"],"names":[],"mappings":"AAAA;CACC,YAAY;AACb","sourcesContent":[".errorBox {\n\tmargin: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorBox": `N8gd1raMmPQs9pEAM1SS`
};
export default ___CSS_LOADER_EXPORT___;
